import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ThemeComponent } from './theme/theme.component';
import { LayoutModule } from './theme/layouts/layout.module';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ScriptLoaderService } from "./_services/script-loader.service";
import { ThemeRoutingModule } from "./theme/theme-routing.module";
import { AuthModule } from "./auth/auth.module";


import { appconst } from '../environments/app-const';
import { environment } from '../environments/environment';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireStorageModule } from 'angularfire2/storage';

import { AfsDatabaseServiceService } from '../app/_services/afs-database-service.service';
import { BackendService } from '../app/_services/backend-service';
import { UtilsService } from '../app/_services/utils.service';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { ToastrModule } from 'ngx-toastr';
import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from '../app/auth/token.interceptor';
import { UploadFormComponent } from './theme/pages/default/upload-form/upload-form.component';
import { NgProgressModule } from 'ngx-progressbar';
import { ImgFallbackModule } from 'ngx-img-fallback';
import { ReversePipe } from "../app/_pipes/reverse.pipe";
import {NgcCookieConsentModule, NgcCookieConsentConfig} from 'ngx-cookieconsent';
import { DropZoneDirective } from './_directives/drop-zone.directive';
import { FileSizePipe } from './_pipes/file-size.pipe';
import { ContactModalContentComponent } from "./theme/pages/default/contacts/contact-modal/contact-modal.component";
import { ConfirmDialogModule, ConfirmationService, SharedModule } from 'primeng/primeng';
import { FileUploadModule } from '../app/theme/layouts/file-upload/file-upload.module';
import { TagInputModule } from 'ngx-chips';
import {ShowErrorsComponent} from "./_validators/show-errors.component";
import {NgxMaskModule} from 'ngx-mask'

const cookieConfig:NgcCookieConsentConfig = {
    cookie: {
        domain: 'app.gigwizer.com' // or 'your.domain.com' // it is mandatory to set a domain, for cookies to work properly (see https://goo.gl/S2Hy2A)
    },
    "position": "bottom-right",
    "theme": "edgeless",
    "palette": {
        "popup": {
            "background": "#000000",
            "text": "#ffffff",
            "link": "#ffffff"
        },
        "button": {
            "background": "#716aca",
            "text": "#000000",
            "border": "transparent"
        }
    },
    "type": "info",
    "content": {
        "message": "This website uses cookies to ensure you get the best experience on our website.",
        "dismiss": "Got it!",
        "deny": "Refuse cookies",
        "link": "Learn more",
        "href": "/assets/pages/privacypolicy.html"
    }
};

export const firebaseConfig = environment.firebaseConfig;

@NgModule({
    declarations: [
        ThemeComponent,
        AppComponent,
        UploadFormComponent,
        ReversePipe,
        ContactModalContentComponent
    ],
    entryComponents: [
        ContactModalContentComponent
    ],
    imports: [
        LayoutModule,
        BrowserModule,
        NgcCookieConsentModule.forRoot(cookieConfig), // import Angular's CookieLaw modules
        BrowserAnimationsModule,
        ImgFallbackModule,
        ToastrModule.forRoot({
            timeOut: 10000,
            positionClass: 'toast-top-right',
            preventDuplicates: true,
            newestOnTop: true,
            enableHtml: true,
            closeButton: true,
            maxOpened: 3
        }),
        ConfirmDialogModule,
        SharedModule,
        FileUploadModule,
        AppRoutingModule,
        ThemeRoutingModule,
        AuthModule,
        AngularFireModule.initializeApp(firebaseConfig),
        AngularFirestoreModule, //.enablePersistence(),
        AngularFireAuthModule,
        AngularFireStorageModule,
        ReactiveFormsModule,
        NgbModule.forRoot(),
        HttpClientModule,
        NgProgressModule,
        TagInputModule,
        NgxMaskModule.forRoot()
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        },
        ScriptLoaderService,
        AfsDatabaseServiceService,
        BackendService,
        UtilsService,
        ConfirmationService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }


// WEBPACK FOOTER //
// ./src/app/app.module.ts